( function( app ) {
  const COMPONENT = {
    className: 'large-video-cta',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'large-video-cta', COMPONENT );
} )( app );
